import {UsersService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _UsersService = new UsersService({client});
export {_UsersService as UsersService};
